import React, { CSSProperties } from "react";
import styles from "./topBarIcon.module.scss";
import DynamicSvgIcon from "features/shared/components/icons/DynamicSvgIcon";
import { existsModule } from "features/shared/helpers/modules";

type Props = {
  iconName: string;
  iconSize?: number;
};

const TopBarIcon = ({ iconName, iconSize }: Props) => {
  // helpers
  const getIconSize = (): CSSProperties | undefined => {
    if (iconSize) {
      return {
        fontSize: `${iconSize}rem`,
      };
    }
  };

  // render
  if (existsModule(`icons/${iconName}.svg`)) {
    return (
      <div className={`svg-inline--fa ${styles.iconItem}`}>
        <DynamicSvgIcon
          name={iconName}
          className="svg-inline--fa"
          style={getIconSize()}
        />
      </div>
    );
  } else {
    console.log(`Icon with name "${iconName}" doesn't exists.`);
    return <></>;
  }
};

export default TopBarIcon;
